import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import { Provider, rootStore } from './models/Root';
import * as serviceWorker from './serviceWorker';
import { createMuiTheme, ThemeProvider } from '@material-ui/core/styles';
import * as firebase from 'firebase/app';
import 'firebase/analytics';

const FIREBASE_CONFIG = {
    development: { // Có thể tự tạo firebase bằng account cá nhân để test
        apiKey: "AIzaSyBGj4XH3V4QHEpaXDr5vdi4KqGfxLZle8w",
        authDomain: "da-vuongquangtuy-1527563087003.firebaseapp.com",
        databaseURL: "https://da-vuongquangtuy-1527563087003.firebaseio.com",
        projectId: "da-vuongquangtuy-1527563087003",
        storageBucket: "da-vuongquangtuy-1527563087003.appspot.com",
        messagingSenderId: "1053847891089",
        appId: "1:1053847891089:web:460ec0435601b9af822330",
        measurementId: "G-SL8NFJWPKN"
    },
    production: {
        apiKey: "AIzaSyC979u5mWkCDFOvVdsXq1FxhzNzi4NOic4",
        authDomain: "abcs-f3b20.firebaseapp.com",
        databaseURL: "https://abcs-f3b20.firebaseio.com",
        projectId: "abcs-f3b20",
        storageBucket: "abcs-f3b20.appspot.com",
        messagingSenderId: "541937253376",
        appId: "1:541937253376:web:31189fe40af55ac6abace5",
        measurementId: "G-5E022D02BM"
    }
}

firebase.initializeApp(FIREBASE_CONFIG[process.env.NODE_ENV])
rootStore.analytics = firebase.analytics()
const theme = createMuiTheme({
    palette: {
        primary: {
            main: '#3eb249',
        },
    }
});
ReactDOM.render(
    <React.StrictMode>
        <ThemeProvider theme={theme}>
            <Provider value={rootStore}>
                <App />
            </Provider>
        </ThemeProvider>
    </React.StrictMode>,
    document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
